import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Palette, Layers, Gift } from 'lucide-react';
const modules = [{
  icon: Brain,
  label: 'Módulo 1',
  name: 'Pare de criar no improviso',
  description: 'Como pensar como quem cobra caro',
  points: ['Decisões estéticas com critério, não por gosto pessoal', 'Elevar valor percebido sem aumentar custo']
}, {
  icon: Palette,
  label: 'Módulo 2',
  name: 'Escolha o que valoriza',
  description: 'Como evitar os erros que barateiam seus produtos',
  points: ['Alinhar proposta, estilo e expectativa com o cliente', 'Definir a categoria correta da lembrancinha']
}, {
  icon: Layers,
  label: 'Módulo 3',
  name: 'A fórmula visual',
  description: 'Como montar combinações que fazem o cliente entender por que pagar mais',
  points: ['A Fórmula Efeito Boutique™ para montar com elegância', 'Controlar proporção, atenção e leitura visual']
}];
export function FeaturesSection() {
  return <section id="estrutura-metodo" className="py-8 md:py-12 bg-white overflow-hidden" data-id="element-112">
      <div className="max-w-4xl mx-auto px-6" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 md:mb-8" data-id="element-114">
          <h2 className="text-2xl md:text-4xl font-bold text-stone-900" data-id="element-115">
            A Estrutura do Método
          </h2>
        </motion.div>

        {/* Modules Stacked */}
        <div className="flex flex-col gap-8" data-id="element-116">
          {modules.map((module, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.5
        }} className="relative bg-gradient-to-br from-white to-stone-50 pt-10 pb-4 px-4 md:pt-12 md:pb-6 md:px-6 rounded-xl border-2 border-stone-100 hover:border-brand-200 hover:shadow-lg hover:shadow-brand-50 transition-all duration-300 group" data-id="element-117">
              {/* Centered icon on top border */}
              <div className="absolute -top-5 left-1/2 -translate-x-1/2" data-id="element-118">
                <div className="w-10 h-10 bg-brand-500 rounded-lg flex items-center justify-center shadow-md shadow-brand-200 group-hover:scale-110 transition-transform duration-300" data-id="element-119">
                  <module.icon className="w-5 h-5 text-white" strokeWidth={2.5} data-id="element-120" />
                </div>
              </div>

              <div className="text-center mb-3" data-id="element-121">
                <p className="text-xs md:text-sm text-stone-400 tracking-wide mb-1" data-id="element-122">
                  {module.label}
                </p>
                <h3 className="text-base md:text-lg font-bold text-brand-600" data-id="element-123">
                  {module.name}
                </h3>
              </div>

              <p className="text-sm md:text-[15px] text-stone-600 mb-3 text-center" data-id="element-124">
                {module.description}
              </p>

              <ul className="space-y-1.5 pl-1" data-id="element-125">
                {module.points.map((point, i) => <li key={i} className="flex items-start gap-2.5 text-sm md:text-base text-stone-700" data-id="element-126">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-500 mt-2 flex-shrink-0" data-id="element-127"></span>
                    <span className="leading-snug" data-id="element-128">{point}</span>
                  </li>)}
              </ul>
            </motion.div>)}

          {/* Bonus Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.24,
          duration: 0.5
        }} className="bg-gradient-to-br from-green-50 to-white p-4 md:p-6 rounded-xl border-2 border-green-200 hover:border-green-300 hover:shadow-lg hover:shadow-green-50 transition-all duration-300 group relative overflow-hidden" data-id="element-129">
            <div className="absolute top-3 right-3 md:top-4 md:right-4" data-id="element-130">
              <span className="bg-green-500 text-white text-[10px] md:text-xs font-bold px-2.5 py-1 rounded-full shadow-md" data-id="element-131">
                BÔNUS
              </span>
            </div>

            <div className="flex items-center gap-3 mb-3" data-id="element-132">
              <div className="w-10 h-10 bg-green-500 rounded-lg flex items-center justify-center shadow-md shadow-green-200 group-hover:scale-110 transition-transform duration-300" data-id="element-133">
                <Gift className="w-5 h-5 text-white" strokeWidth={2.5} data-id="element-134" />
              </div>
              <h3 className="text-base md:text-lg font-bold text-stone-900" data-id="element-135">
                40 Ideias Validadas
              </h3>
            </div>

            <ul className="space-y-1.5 pl-1" data-id="element-136">
              <li className="flex items-start gap-2.5 text-sm md:text-base text-stone-700" data-id="element-137">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 flex-shrink-0" data-id="element-138"></span>
                <span className="leading-snug" data-id="element-139">
                  40 ideias escolhidas a dedo para aplicar o método na prática
                </span>
              </li>
              <li className="flex items-start gap-2.5 text-sm md:text-base text-stone-700" data-id="element-140">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500 mt-2 flex-shrink-0" data-id="element-141"></span>
                <span className="leading-snug" data-id="element-142">
                  Cada ideia mostra como pequenas decisões mudam completamente a
                  percepção do produto
                </span>
              </li>
            </ul>
          </motion.div>
        </div>

        {/* CTA Button */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="text-center mt-8" data-id="element-143">
          <button onClick={() => {
          const section = document.getElementById('pricing');
          if (section) {
            section.scrollIntoView({
              behavior: 'smooth'
            });
          }
        }} className="bg-brand-500 hover:bg-brand-600 text-white font-bold text-sm md:text-base px-6 py-3 md:px-8 md:py-4 rounded-full shadow-lg shadow-brand-200 hover:shadow-brand-300 transition-all duration-300" data-id="element-144">
            👉 Sim, quero transformar minha apresentação agora
          </button>
        </motion.div>
      </div>
    </section>;
}